import { render, staticRenderFns } from "./TicketColumnPicker.vue?vue&type=template&id=6c4dc225&scoped=true&"
import script from "./TicketColumnPicker.vue?vue&type=script&lang=js&"
export * from "./TicketColumnPicker.vue?vue&type=script&lang=js&"
import style0 from "./TicketColumnPicker.vue?vue&type=style&index=0&id=6c4dc225&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4dc225",
  null
  
)

export default component.exports